'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TextEffect: ()=>TextEffect
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_namespaceObject = require("motion/react");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const defaultStaggerTimes = {
    char: 0.03,
    word: 0.05,
    line: 0.1
};
const defaultContainerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.05
        }
    },
    exit: {
        transition: {
            staggerChildren: 0.05,
            staggerDirection: -1
        }
    }
};
const defaultItemVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1
    },
    exit: {
        opacity: 0
    }
};
const presetVariants = {
    blur: {
        container: defaultContainerVariants,
        item: {
            hidden: {
                opacity: 0,
                filter: 'blur(12px)'
            },
            visible: {
                opacity: 1,
                filter: 'blur(0px)'
            },
            exit: {
                opacity: 0,
                filter: 'blur(12px)'
            }
        }
    },
    'fade-in-blur': {
        container: defaultContainerVariants,
        item: {
            hidden: {
                opacity: 0,
                y: 20,
                filter: 'blur(12px)'
            },
            visible: {
                opacity: 1,
                y: 0,
                filter: 'blur(0px)'
            },
            exit: {
                opacity: 0,
                y: 20,
                filter: 'blur(12px)'
            }
        }
    },
    scale: {
        container: defaultContainerVariants,
        item: {
            hidden: {
                opacity: 0,
                scale: 0
            },
            visible: {
                opacity: 1,
                scale: 1
            },
            exit: {
                opacity: 0,
                scale: 0
            }
        }
    },
    fade: {
        container: defaultContainerVariants,
        item: {
            hidden: {
                opacity: 0
            },
            visible: {
                opacity: 1
            },
            exit: {
                opacity: 0
            }
        }
    },
    slide: {
        container: defaultContainerVariants,
        item: {
            hidden: {
                opacity: 0,
                y: 20
            },
            visible: {
                opacity: 1,
                y: 0
            },
            exit: {
                opacity: 0,
                y: 20
            }
        }
    }
};
const AnimationComponent = /*#__PURE__*/ external_react_default().memo(({ segment, variants, per, segmentWrapperClassName })=>{
    const content = 'line' === per ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.span, {
        variants: variants,
        className: "block",
        children: segment
    }) : 'word' === per ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.span, {
        "aria-hidden": "true",
        variants: variants,
        className: "inline-block whitespace-pre",
        children: segment
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.span, {
        className: "inline-block whitespace-pre",
        children: segment.split('').map((char, charIndex)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.span, {
                "aria-hidden": "true",
                variants: variants,
                className: "inline-block whitespace-pre",
                children: char
            }, `char-${charIndex}`))
    });
    if (!segmentWrapperClassName) return content;
    const defaultWrapperClassName = 'line' === per ? 'block' : 'inline-block';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
        className: (0, index_cjs_namespaceObject.cn)(defaultWrapperClassName, segmentWrapperClassName),
        children: content
    });
});
AnimationComponent.displayName = 'AnimationComponent';
const splitText = (text, per)=>{
    if ('line' === per) return text.split('\n');
    return text.split(/(\s+)/);
};
const hasTransition = (variant)=>'object' == typeof variant && null !== variant && 'transition' in variant;
const createVariantsWithTransition = (baseVariants, transition)=>{
    if (!transition) return baseVariants;
    const { exit, ...mainTransition } = transition;
    return {
        ...baseVariants,
        visible: {
            ...baseVariants.visible,
            transition: {
                ...hasTransition(baseVariants.visible) ? baseVariants.visible.transition : {},
                ...mainTransition
            }
        },
        exit: {
            ...baseVariants.exit,
            transition: {
                ...hasTransition(baseVariants.exit) ? baseVariants.exit.transition : {},
                ...mainTransition,
                staggerDirection: -1
            }
        }
    };
};
function TextEffect({ children, per = 'word', as = 'p', variants, className, preset = 'fade', delay = 0, speedReveal = 1, speedSegment = 1, trigger = true, onAnimationComplete, onAnimationStart, segmentWrapperClassName, containerTransition, segmentTransition, style }) {
    const segments = splitText(children, per);
    const MotionTag = react_namespaceObject.motion[as];
    const baseVariants = preset ? presetVariants[preset] : {
        container: defaultContainerVariants,
        item: defaultItemVariants
    };
    const stagger = defaultStaggerTimes[per] / speedReveal;
    const baseDuration = 0.3 / speedSegment;
    const customStagger = hasTransition(variants?.container?.visible ?? {}) ? variants?.container?.visible.transition?.staggerChildren : void 0;
    const customDelay = hasTransition(variants?.container?.visible ?? {}) ? variants?.container?.visible.transition?.delayChildren : void 0;
    const computedVariants = {
        container: createVariantsWithTransition(variants?.container || baseVariants.container, {
            staggerChildren: customStagger ?? stagger,
            delayChildren: customDelay ?? delay,
            ...containerTransition,
            exit: {
                staggerChildren: customStagger ?? stagger,
                staggerDirection: -1
            }
        }),
        item: createVariantsWithTransition(variants?.item || baseVariants.item, {
            duration: baseDuration,
            ...segmentTransition
        })
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.AnimatePresence, {
        mode: "popLayout",
        children: trigger && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(MotionTag, {
            initial: "hidden",
            animate: "visible",
            exit: "exit",
            variants: computedVariants.container,
            className: className,
            onAnimationComplete: onAnimationComplete,
            onAnimationStart: onAnimationStart,
            style: style,
            children: [
                'line' !== per ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                    className: "sr-only",
                    children: children
                }) : null,
                segments.map((segment, index)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(AnimationComponent, {
                        segment: segment,
                        variants: computedVariants.item,
                        per: per,
                        segmentWrapperClassName: segmentWrapperClassName
                    }, `${per}-${index}-${segment}`))
            ]
        })
    });
}
exports.TextEffect = __webpack_exports__.TextEffect;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TextEffect"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
